import React, { useState, useEffect } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { format } from "date-fns";
import Loading from "../../Student/Reusablecomponents/Loading";
const Allusers = (props) => {
    const [AllUsersData, SetAllUsersData] = useState([]);
    const [loading, setLoading] = useState(false);
    const GetAlluserdata = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetOverallQBStatusTrack_AllUsers?SubjectId=${props.subjectId}&pageno=1&pagesize=10&pagination=0`);
            SetAllUsersData(res.data);
            props.StoreAll(res.data);
            setLoading(false);
        }
        catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        GetAlluserdata();
    }, [props.subjectId])

    const OverAllColumns = [
        { name: "Grade", selector: "grade", sortable: true, },
        { name: "CBSE / SCERT Chapter No", selector: "chapterNo", sortable: false, cell: (row) => (row.chapterNo === 0 ? "" : row.chapterNo), },
        ...(props.subjectId === 1
            ? [
                { name: "Content", selector: "content", sortable: true, },
            ]
            : []),
        ...(props.subjectId === 3 ? [{ name: "Book", selector: "book", sortable: true }] : []),
        ...(props.subjectId !== 3 ? [{ name: "Topic", selector: "topic", sortable: true, },
        { name: "Subtopic", selector: "subTopic", sortable: true, },] : []),
        { name: "Learning Outcome", selector: "learningOutcome", sortable: true },
        ...(props.subjectId !== 3 ? [
            { name: "Sub-Learning Outcome", selector: "subLO", sortable: true, },
            { name: "NCERT Learning Outcome", selector: "ncertlo", sortable: true, },
        ] : []),
        { name: "Source", selector: "source", sortable: true, },
        { name: "ScenarioID", selector: "scenarioID", sortable: true, cell: (row) => (row.scenarioID === 0 ? "" : row.scenarioID), },
        { name: "QuestionID", selector: "questionID", sortable: false, },
        { name: "QB creator name", selector: "qbCreator", sortable: true },
        { name: "Created Date", selector: "createdDate", sortable: true, cell: (row) => row.createdDate ? format(new Date(row.createdDate), "dd-MM-yyyy") : "", },
        { name: "QB Status", selector: "qcStatus", sortable: true },
        { name: "QC done by", selector: "qcDoneBy", sortable: true, },

        { name: "QC Completion Date", selector: "qcCompletionDate", sortable: true, cell: (row) => row.qcCompletionDate ? format(new Date(row.qcCompletionDate), "dd-MM-yyyy") : "", },
        ...(props.subjectId === 1
            ? [
                { name: "Cloned/Original", selector: "clonedorOriginal", sortable: true, },
            ]
            : []),

        { name: "Alignment of Items with Standard", selector: "alignmentofItemswithStandard", sortable: true, },
        { name: "Stem of Question", selector: "stemofquestion", sortable: true, },
        { name: "MCQs Options", selector: "mcQsOptions", sortable: true, },
        { name: "Item Bias and Sensitivity Issues", selector: "itemBiasandSensitivityIssues", sortable: true, },
        { name: "Image Quality and Relevance", selector: "imageQualityandRelevance", sortable: true, },
        { name: "Grammar and Layout", selector: "grammarandLayout", sortable: true, },

        ...(props.subjectId !== 3 ? [
            { name: "Translation date (Using AI)", selector: "createdDate", sortable: true, cell: (row) => row.createdDate ? format(new Date(row.createdDate), "dd-MM-yyyy") : "", },
            { name: "QC Status of translated question", selector: "qcTranslationStatus", sortable: true },
            { name: "QC Completion Date for translated question", selector: "qcTranslationCompletionDate", sortable: true, cell: (row) => row.qcTranslationCompletionDate ? format(new Date(row.qcTranslationCompletionDate), "dd-MM-yyyy") : "", },
            { name: "QC Translation done by", selector: "qcTranslationDoneBy", sortable: true, },
            { name: "Type of Issue", selector: "typeOfIssue", sortable: true, },
        ] : []),
    ];
    return (
        <>
            <DataTable className="NCLDataTable Card mt-3"
                data={AllUsersData} columns={OverAllColumns}
                // columns={questionType !== "0" ? OverAllColumns : Columns}
                // CountPage={SetPageCount}
                Dropdownvalues={["10", "25", "50", "100"]}
                ShowPagination={true} ShowPagecount={true} tableMinWidth="94vw" />
                {loading && <Loading />}
        </>
    )
}
export default Allusers;